// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__IkHBp","selected":"Chip_selected__3AmnT"};